import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_CUSTOM_TONE_OF_VOICE } from './schema';

const MUTATION = gql`
  mutation ExtractCustomToneOfVoiceFromEditor(
    $customerId: ID!
    $brandVoiceId: ID!
    $url: String
    $text: String
    $resourceId: ID
    $inputType: TovExtractionInputTypeEnum
    $language: String
  ) {
    extractCustomToneOfVoiceFromEditor(
      customerId: $customerId
      brandVoiceId: $brandVoiceId
      url: $url
      text: $text
      resourceId: $resourceId
      inputType: $inputType
      language: $language
    ) {
      ...CustomToneOfVoice
    }
  }
  ${FRAGMENT_CUSTOM_TONE_OF_VOICE}
`;

export const extractCustomToneOfVoiceFromEditor = ({
  customerId,
  url,
  text,
  resourceId,
  inputType,
  language,
  brandVoiceId,
}) => {
  return executeGqlMutation({
    mutation: MUTATION,
    variables: { customerId, url, text, resourceId, inputType, language, brandVoiceId },
    options: {
      traceAcRequests: true,
    },
  }).then(({ data }) => getSingleProp(data));
};
